import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import { seocontentwritingfold1 } from "../../asserts/images";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

const GhostWriter = () => {
  return (
    <>

      <Helmet>
        <meta charSet="utf-8" />
        <title>
            SEO Content Writing Services | Falcon Book Writing
        </title>
        <meta
          name="description"
          content="Falcon Book Writing offers expert SEO Content Writing Services, helping authors and businesses create optimized, engaging content that drives traffic and sales."
        />
        <meta name="keywords" content="SEO Content Writing Services" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <UserLayout>
        <InnerHero
          innerheroclass="ghostwritingBg seocontentwritingbg"
          // title="The Perfect"
          subtitle=" SEO Content Writing "
          title2="That Ranks, Engages, and Converts"
          para="Our SEO content writing blends strategy with creativity, designed to attract traffic, engage readers, and inspire action. Every word is optimized to boost visibility, strengthen your brand, and turn visitors into loyal customers."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section innerpages-sec-2"
          title={`SEO Writing That Builds  `}
          subtitle="  Trust and Authority "
          // title2="As That!"
          description={`Effective SEO writing does more than improve rankings, it builds credibility. Every piece of content is crafted to position your brand as a trusted authority in its niche. Through well-researched topics, relevant keywords, and engaging storytelling, we create content that not only attracts traffic but earns loyalty. Our focus goes beyond algorithms; we write to connect with real readers while meeting search engine standards. From blog posts to web pages, each word is chosen to inform, inspire, and convert. The result? Content that performs well in search results while building lasting trust with your audience. With strategic SEO writing, your brand doesn’t just get noticed, it becomes recognized as an expert voice that drives engagement, trust, and growth. `}
          // subtitle1="How we work?"
          // subtitle1Desc="At Random House Publishers, we pride ourselves on being the conduit through which your imagination flows into the world. Our ghostwriting service is designed to empower authors like you to bring your stories to life, even if you need a little extra support along the way. Here’s how we work for you:"
          // subtitle2="    Tailored Collaborations?"
          // subtitle2Desc="We understand that every author is unique, and so are their needs. That’s why we offer personalized ghostwriting services tailored to your specific vision and requirements. Whether you have a fully fleshed-out plot or just a spark of an idea, our team of experienced ghostwriters will work closely with you to bring your story to fruition."
          // subtitle3="  Expert Guidance"
          // subtitle3Desc="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. From brainstorming sessions to plot development and character arcs, we’ll be there to guide you every step of the way."
          // subtitle3Desc2="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. "
          image={seocontentwritingfold1}
          imgClass="ghost-img2"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default GhostWriter;
